//eslint-disable-next-line import/no-default-export
export default [
    {
        title: 'Financiero',
        fontIcon: 'university',
        resource: 'Financiero',
        action: 'ver-financiero',
        children: [
            {
                title: 'Dashboard',
                icon: 'LayoutIcon',
                resource: 'Financiero',
                action: 'ver-financiero-dashboard',
            },
            {
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Financiero',
                action: 'ver-financiero-configuracion',
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Financiero',
                action: 'ver-financiero-mantenimiento',
                children: [
                    {
                        route: 'financiero-administracion-clientes',
                        title: 'Clientes',
                        fontIcon: 'user-tie',
                        resource: 'Financiero',
                        action: 'ver-financiero-administracion-clientes',
                    },
                    {
                        route: 'financiero-administracion-deudores',
                        title: 'Deudores',
                        fontIcon: 'money-check-alt',
                        resource: 'Financiero',
                        action: 'ver-financiero-administracion-deudores',
                    },
                    {
                        route: 'financiero-activar-cuentas-bancarias',
                        title: 'Cuentas Bancarias',
                        resource: 'Financiero',
                        action: 'ver-financiero-activar-cuentas-bancarias',
                    },
                ],
            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Financiero',
                action: 'ver-financiero-transacciones',
                children: [
                    {
                        route: 'financiero-aprobacion-ordenes-requisicion',
                        title: 'Aprob Ord. Req.',
                        resource: 'Financiero',
                        action: 'ver-financiero-aprobacion-ordenes-requisicion',
                    },
                    {
                        route: 'financiero-administacion',
                        title: 'Operaciones Bancarias',
                        resource: 'Financiero',
                        action: 'ver-financiero-administacion',
                    },
                    {
                        route: 'financiero-provisiones-mensuales',
                        title: 'Provisiones Mensuales de Operaciones Bancarias',
                        resource: 'Financiero',
                        action: 'ver-financiero-provisiones-mensuales',
                    },
                    {
                        route: 'financiero-archivos-transferencia',
                        title: 'Archivos Transferencia',
                        resource: 'Financiero',
                        action: 'ver-financiero-archivos-transferencia',
                    },
                ],
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Financiero',
                action: 'ver-financiero-informes',
                children: [
                    {
                        route: 'financiero-reportes',
                        title: 'Operaciones',
                        resource: 'Financiero',
                        action: 'ver-financiero-reportes',
                    },
                    {
                        route: 'financiero-reportes-stock-inventario',
                        title: 'Stock de Inventario',
                        resource: 'Financiero',
                        action: 'ver-financiero-reportes-stock-inventario',
                    },
                    {
                        route: 'financiero-seguimiento-operaciones',
                        title: 'Seguimiento de Operaciones',
                        resource: 'Financiero',
                        action: 'ver-financiero-seguimiento-operaciones',
                    },
                ],
            },
        ],
    },
]
